module.exports = __webpack_public_path__ + "static/media/img_Inscription_syuku@2x.de4c0786.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@2x/img_Inscription_syuku@2x.png
// module id = 978
// module chunks = 0